import React, { Component } from 'react'
import MaskedInput from 'react-text-mask'
import Moment from 'moment'
import { connect } from 'react-redux'
import { Grid, Col, Row } from 'react-bootstrap'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import Dialog from 'material-ui/Dialog'
import Checkbox from 'material-ui/Checkbox'

import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import Snackbar from 'material-ui/Snackbar'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import IconMenu from 'material-ui/IconMenu'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import AddCircle from 'material-ui/svg-icons/content/add-circle'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'

import Thread from '../inbox/threads'

import { setContact } from '../../reducers/inbox/actions'
import {
  getContactByCompany,
  getContactDetails,
  deleteContact,
  downloadContact
} from '../../reducers/contact/resources'
import { updateContactData } from '../../reducers/contact-detail/resources'
import { getCompanyContactsByMobile } from '../../reducers/contact/resources'
import {
  saveGroup,
  addContactsToGroup,
  deleteContactsInGroup,
} from '../../reducers/group/resources'
import { getAllGroups } from '../../reducers/campaign/resources'

import objUtil from '../../utils/object'
import format from '../../utils/format'
import { evaluateTCPA } from '../../utils/tcpa'

import _ from 'lodash'

import '../inbox/index.css'
import './index.css'

const OPTED_IN_OPTION = 0
const OPTED_OUT_OPTION = 1

class Profile extends Component {
  componentWillMount = () => {
    const fields = this.getFields()

    let state = {
      contact: {},
      showSnackBar: false,
      snackBarMessage: '',
      isAdd: false,
      showFooter: false,
      fieldErrors: {
        firstname: '',
        lastname: '',
        mobile: '',
        email: ''
      },
      optStatus: null,
      groupMenuOpen: false,
      anchorEl: null,
      openAddToGroupDialog: false,
      openCreateGroupDialog: false,
      addThisContactToNewGroup: true,
      newGroupName: '',
      newGroupIsPrivate: false,
      groups: [],
    }

    state.fields = {}
    fields.contacts.forEach((field) => {
      state.fields[field] = ''
    })
    fields.contactdetails.forEach((field) => {
      state.fields[field] = ''
    })

    const { contactId } = this.props.match.params

    ;(async () => {
      try {
        await this.setState(state)
        let payload = await getContactDetails(contactId)
        let contact = payload.data.contact
        let contactDetails = contact.contactdetails

        const mobile = contact.mobile
          ? format.mobileCleanup(contact.mobile)
          : ''
        contact.mobile = mobile.length > 10 ? mobile.substring(1) : mobile

        const mobileContactDetails = contactDetails.find(
          (contact) => contact.field === 'mobile',
        )
        if (mobileContactDetails && mobileContactDetails.value) {
          let mobileContactValue = mobileContactDetails.value
          mobileContactValue = mobileContactValue.replace(/\s|\+|/g, '')
          mobileContactDetails.value =
            mobileContactValue.length > 10
              ? mobileContactValue.substring(1)
              : mobileContactValue
        }

        const groups = await getAllGroups()

        state = {
          ...state,
          contact,
          groups: groups.data,
          origDetails: contactDetails,
        }

        const fields = this.setFieldValues({ contact, contactDetails })
        state.fields = fields
        state.origFields = this.setFieldValues(
          { contact, contactDetails },
          true,
        )

        // Check for Opt in/out status
        state.optStatus = this.handleCheckOptStatus(state)

        if (contact.humanparser) {
          state.showFooter = true
        }

        this.props.setContact(contact)

        await this.setState(state)
      } catch (error) {
        if (error.message === 'Contact does not exist') {
          this.props.history.push('/contacts')
        }
      }
    })()
  }

  getFields = () => {
    return {
      contacts: ['notes', 'status'],
      contactdetails: [
        'firstname',
        'lastname',
        'email',
        'mobile',
        'employmentType',
        'shift',
        'flexibleShifts',
        'interest',
        'decisionPoint',
        'agreement',
        'optedInDate',
        'optedOutDate',
      ],
    }
  }

  showGroupMenu = (event) => {
    event.preventDefault()
    this.setState({
      groupMenuOpen: true,
      anchorEl: event.currentTarget,
    })
  }

  hideGroupMenu = () => {
    this.setState({
      groupMenuOpen: false,
    })
  }

  openAddToGroupDialog = () => {
    this.setState({
      openAddToGroupDialog: true,
      groupMenuOpen: false,
    })
  }
  closeAddToGroupDialog = () => {
    this.setState({
      openAddToGroupDialog: false,
    })
  }

  removeContactFromGroup = async (groupId) => {
    try {
      await deleteContactsInGroup(groupId, {
        contacts: [this.state.contact.id],
      })

      getContactDetails(this.state.contact.id).then((payload) => {
        this.setState({
          contact: payload.data.contact,
          showSnackBar: true,
          snackBarMessage: 'Contact removed from group',
        })
      })
    } catch (error) {
      this.setState({
        showSnackBar: true,
        snackBarMessage: 'Unable to remove contact from group.',
      })
      return
    }
  }

  addContactToGroup = async (groupId) => {
    try {
      await addContactsToGroup(groupId, {
        contacts: [this.state.contact.id],
      })

      getContactDetails(this.state.contact.id).then((payload) => {
        this.setState({
          contact: payload.data.contact,
          showSnackBar: true,
          snackBarMessage: 'Contact added to group.',
        })
      })
    } catch (error) {
      this.setState({
        showSnackBar: true,
        snackBarMessage: 'Unable to add contact to group.',
      })
      return
    }
  }

  openCreateGroupDialog = () => {
    this.setState({
      openCreateGroupDialog: true,
      groupMenuOpen: false,
      addThisContactToNewGroup: true,
      newGroupName: '',
      newGroupIsPrivate: false,
    })
  }

  closeCreateGroupDialog = () => {
    this.setState({
      openCreateGroupDialog: false,
    })
  }

  createNewGroup = async () => {
    const {
      newGroupName,
      newGroupIsPrivate,
      addThisContactToNewGroup,
      contact,
    } = this.state
    if (newGroupName.length === 0) {
      this.setState({
        showSnackBar: true,
        snackBarMessage: 'New group name must not be empty.',
      })
      return
    }

    let groupContacts = addThisContactToNewGroup ? [contact.id] : []

    const data = {
      groupName: newGroupName,
      groupContacts: JSON.stringify(groupContacts),
      isPrivate: newGroupIsPrivate,
    }

    try {
      await saveGroup(data)
      const groups = await getAllGroups()

      getContactDetails(contact.id).then((payload) => {
        this.setState({
          groups: groups.data,
          contact: payload.data.contact,
          openCreateGroupDialog: false,
          showSnackBar: true,
          snackBarMessage: 'Group successfully created',
        })
      })
    } catch (error) {
      let msg
      if (error.statusCode === 500) {
        // duplicate group name
        msg = 'Group name already taken'
      }
      this.setState({
        showSnackBar: true,
        snackBarMessage: msg || error.message,
      })
    }
  }

  setFieldValues = (contactData, isOrig) => {
    const { contact, contactDetails } = contactData
    const fields = this.getFields()

    const fieldValues = {}

    fields.contacts.forEach((field) => {
      fieldValues[field] = contact[field] || ''
    })
    fields.contactdetails.forEach((field) => {
      fieldValues[field] = (
        _.find(contactDetails, { field }) || { value: '' }
      ).value
    })

    if (
      !isOrig &&
      fieldValues.firstname === '' &&
      fieldValues.lastname === '' &&
      contact.name !== ''
    ) {
      const { firstName, lastName } = contact.humanparser
      fieldValues.firstname = firstName
      fieldValues.lastname = lastName
    }

    return fieldValues
  }

  componentDidUpdate(props) {
    if (this.state.isAdd && !this.index) {
      this.index += 1
    }
  }

  handleSnackBarClose = () => {
    this.setState({
      showSnackBar: false,
      snackBarMessage: '',
    })
  }

  handleUpdateBot = (data) => {
    let state = { ...this.state }

    const index = _.findIndex(state.conversation, {
      botmap_id: data.convoRes.botmap_id,
    })
    let newConvo = state.conversation[index]

    newConvo = {
      ...newConvo,
      ...data.convoRes,
    }

    state.conversation.splice(index, 1, newConvo)
    this.setState(state)
  }

  cleanMobileContact = (contact) => {
    const mobile = contact ? format.mobileCleanup(contact) : ''
    return mobile.length > 10 ? mobile.substring(1) : mobile
  }

  getMobileError = async (mobile) => {
    const {contact} = this.state
    if (!mobile.value) return 'This field is required.'
    if (mobile.value.length < 12) return 'Please enter a valid mobile number.'
    const {mobileSearchRes:res} = (await getCompanyContactsByMobile(mobile.value)).data
    if(res.length>0){
      const [self,others] = _.partition(res,{id:contact.id})
      if(others.length>0){
        return 'You cannot add two contacts with the same mobile phone number.'
      }
    }

    return ''
  }

  getEmailError =(email) =>{
    if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(email.value)){
      return 'Please enter a valid email address.'
    }
    return ''
  }

  validateFields = async (contact) => {
    let hasNoError = true
    let { fieldErrors } = this.state

    if (!contact) return hasNoError

    if (contact.contactDetails) {
      const formattedContacts = contact.contactDetails


      const mobile =_.find(formattedContacts,{field:'mobile'});
      if(mobile){
        fieldErrors.mobile = await this.getMobileError(mobile)
        if (fieldErrors.mobile.length > 0){
          hasNoError = false  
        } 
      }

      const email =_.find(formattedContacts,{field:'email'});
      if(email){
        fieldErrors.email =this.getEmailError(email)
        if (fieldErrors.email.length > 0){
          hasNoError = false  
        } 
      }

      formattedContacts.forEach((contact) => {
        if(!(['mobile','email'].includes(contact.field))){
          if (!contact.value || contact.value.length == 0) {
            hasNoError = false
            fieldErrors[contact.field] = 'This field is required'
          } else {
            fieldErrors[contact.field] = ''
          }
        }
      })
    }

    this.setState({ fieldErrors })

    return hasNoError
  }

  handleSaveUpdate = async () => {
    let { fields, origFields, contact } = this.state

    const diffObj = objUtil.getDiffInObj(fields, origFields)

    const data = {}
    const contactdetails = []
    Object.keys(diffObj).forEach(async(ky) => {
      if (ky === 'notes' || ky === 'status') {
        data[ky] = diffObj[ky]
        return
      }

      if (ky === 'mobile') {
        const prefix = '+1'
        const mobile = this.cleanMobileContact(diffObj[ky])
        diffObj[ky] = prefix.concat(mobile)
      }

      contactdetails.push({
        field: ky,
        value: diffObj[ky],
      })
    })

    data.contactDetails = contactdetails

    let checks = await this.validateFields(data);
    if (!checks) {
      this.setState({
        showSnackBar: true,
        snackBarMessage: 'There are errors upon updating the contact.',
      })
      return
    }

    // replace data.contactdetails with this if optStatus was changed
    let appendOptStatusData = this.handleSaveOptStatus(this.state)

    data.contactDetails = JSON.stringify(
      contactdetails.concat(appendOptStatusData),
    )

    updateContactData(contact.id, data)
      .then(() => {
        getContactDetails(contact.id).then((payload) => {
          contact = payload.data.contact
          let contactDetails = contact.contactdetails

          contact.mobile = this.cleanMobileContact(contact.mobile)

          const mobileContactDetails = contactDetails.find(
            (contact) => contact.field === 'mobile',
          )
          if (mobileContactDetails && mobileContactDetails.value) {
            let mobileContactValue = mobileContactDetails.value
            mobileContactValue = mobileContactValue.replace(/\s|\+|/g, '')
            mobileContactDetails.value =
              mobileContactValue.length > 10
                ? mobileContactValue.substring(1)
                : mobileContactValue
          }

          const fields = this.setFieldValues({ contact, contactDetails })

          this.setState({
            contact,
            origDetails: contactDetails,
            fields,
            origFields: fields,
            showFooter: false,
            showSnackBar: true,
            snackBarMessage: 'Updates successfully saved',
          })
        })
      })
      .catch((err) => {
        let errMsg = 'Error in adding contact.'
        if (err.statusCode === 400 && err.message) {
          errMsg = err.message
        }
        this.setState({ showSnackBar: true, snackBarMessage: errMsg })
      })
  }

  assignFieldState = () => {
    const { contact, origDetails } = this.state

    const fields = this.setFieldValues({
      contact,
      contactDetails: origDetails,
    })

    this.setState({ fields, origFields: fields, showFooter: false, fieldErrors: [] })
  }

  checkForUpdates = () => {
    const { fields, contact, origDetails } = this.state

    const origFields = this.setFieldValues(
      { contact, contactDetails: origDetails },
      true,
    )

    if (_.isEqual(fields, origFields)) {
      return this.setState({ showFooter: false, fieldErrors:[] })
    }

    return this.setState({ showFooter: true, origFields })
  }

  handleOnChange = (field) => async (event, value) => {
    const { fields } = this.state

    if (field === 'mobile') {
      value = format.mobileCleanup(value)
      value = value.length > 10 ? value.substring(1) : value
      this.handleMask(value)
    }

    fields[field] = value

    await this.setState({ fields })
    this.checkForUpdates()
  }

  handleChangeNewGroupName = () => async (event, value) => {
    this.setState({
      newGroupName: value,
    })
  }

  handleMask = (value) => {
    if (value.length > 10) {
      return [
        '(',
        /[0-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]
    }
    return [
      '(',
      /[0-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ]
  }

  handleChangeOptStatus = (_, __, value) => {
    if (this.state.optStatus !== value)
      this.setState({ ...this.state, optStatus: value, showFooter: true })
    return
  }

  handleCheckOptStatus = (state) => {
    /*
		let { fields } = state
		if (fields.agreement.toLowerCase() === 'yes' && !!fields.optedInDate && !fields.optedOutDate) return OPTED_IN_OPTION;
		return OPTED_OUT_OPTION; 
		*/

    let { fields } = state

    let isTCPA = OPTED_OUT_OPTION

    try {
      isTCPA = evaluateTCPA(fields)
    } catch (error) {
      console.log(error)
    }

    return isTCPA
  }

  handleSaveOptStatus = (state) => {
    let { optStatus } = state
    let date = Moment().format('YYYY-MM-DD')
    if (optStatus === OPTED_OUT_OPTION) {
      let optOut = {
        field: 'optedOutDate',
        value: date,
      }
      let optIn = {
        field: 'optedInDate',
        value: null,
      }
      return [optOut, optIn]
    }
    if (optStatus === OPTED_IN_OPTION) {
      let optIn = {
        field: 'optedInDate',
        value: date,
      }
      let optOut = {
        field: 'optedOutDate',
        value: null,
      }
      /*
			let agreement = {
				field: 'agreement',
				value: 'yes'
			}
			
			return [optIn, optOut, agreement]
			*/
      return [optIn, optOut]
    }
    return []
  }

  handleDeleteContact = () => {
    if (window.confirm('Are you sure you want to delete this contact?')) {
      ;(async () => {
        try {
          const { id } = this.state.contact
          await deleteContact(id)
          return this.props.history.push('/contacts')
        } catch (error) {
          console.log(error)
        }
      })()
    }
  }


  

  handleDownloadContact = () => {
    
      ;(async () => {
        try {
          const { id } = this.state.contact
          
          downloadContact(
            id
          ).then((res) => {
            console.log(res)
            const link = document.createElement('a')
            link.href = `${res.data.path}`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })



        } catch (error) {
          console.log(error)
        }
      })()
    
  }

  render = () => {
    let styles = {
      txtField: {
        height: 30,
      },
      underline: {
        bottom: '-10px',
      },
      floatingLabel: {
        top: 19,
      },
      errorStyle: {
        bottom: 3,
      },
      footer: {
        display: this.state.showFooter ? 'block' : 'none',
      },
      contactBody: {
        height: this.state.showFooter
          ? 'calc(100% - 275px)'
          : 'calc(100% - 193px)',
        marginTop: '15px',
      },
    }
    let browsingmeta
    let contactGroups
    let availableGroups = []

    const { fields, contact, fieldErrors, groups } = this.state
    const { contactgroups } = contact

    if (groups && groups.length) {
      let joinedGroups =
        contactgroups && contactgroups.length
          ? contactgroups.map((contactgroup) => contactgroup.group.id)
          : []

      this.state.groups.forEach((group) => {
        availableGroups.push(
          <TableRow key={group.id}>
            <TableRowColumn>{group.name}</TableRowColumn>
            <TableRowColumn>{group.contact_count}</TableRowColumn>
            <TableRowColumn>{group.created_at}</TableRowColumn>
            <TableRowColumn style={{ textAlign: 'center' }}>
              {_.includes(joinedGroups, group.id) ? (
                'Joined'
              ) : (
                <RaisedButton
                  label="Add"
                  onClick={() => {
                    this.addContactToGroup(group.id)
                  }}
                  primary={true}
                  style={{ marginRight: '5px' }}
                />
              )}
            </TableRowColumn>
          </TableRow>,
        )
      })
    }

    if (contact.browsingmeta) {
      const { utmSource, utmCampaign, utmMedium } = contact.browsingmeta

      browsingmeta = (
        <div>
          <Row>
            <Col xs={6}>
              <TextField
                className="disabled-field"
                floatingLabelText="Utm Source"
                value={utmSource}
                disabled={true}
                floatingLabelFixed={true}
              />
            </Col>
            <Col xs={6}>
              <TextField
                className="disabled-field"
                floatingLabelText="Utm Campaign"
                value={utmCampaign}
                disabled={true}
                floatingLabelFixed={true}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <TextField
                className="disabled-field"
                floatingLabelText="Utm Medium"
                value={utmMedium}
                disabled={true}
                floatingLabelFixed={true}
              />
            </Col>
          </Row>
        </div>
      )
    }

    if (contactgroups && contactgroups.length) {
      const contactGroupList = contactgroups.map((contactgroup) => {
        // skip if contactgroup was already deleted
        if (contactgroup.group && contactgroup.group.deleted_at) {
          return
        }

        const { id, name, contactgroups } = contactgroup.group

        return (
          <TableRow key={id}>
            <TableRowColumn>{name}</TableRowColumn>
            <TableRowColumn>{contactgroups.length}</TableRowColumn>
            <TableRowColumn>
              <RaisedButton
                label="Remove"
                onClick={() => {
                  this.removeContactFromGroup(id)
                }}
                secondary={true}
              />
            </TableRowColumn>
          </TableRow>
        )
      })

      contactGroups = (
        <div>
          <Row>
            <Table className="contactgroups-table">
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn>Group Name</TableHeaderColumn>
                  <TableHeaderColumn>No. of Contacts</TableHeaderColumn>
                  <TableHeaderColumn>&nbsp;</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {contactGroupList}
              </TableBody>
            </Table>
          </Row>
        </div>
      )
    }

    return (
      <Grid fluid>
        <Row style={{ height: '100%' }}>
          <div className="message-container gohire-profile">
            <Col
              xs={12}
              sm={7}
              className="conversations-wrapper no-padding profile"
            >
              <div style={{ marginLeft: 3 }}>
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 500,
                    marginTop: 15,
                    display: 'inline-block',
                  }}
                >
                  {this.state.contact.name || '----'}
                </div>
                <IconMenu
                  iconButtonElement={
                    <IconButton style={{ padding: '0 12px' }}>
                      <MoreVertIcon />
                    </IconButton>
                  }
                  anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                  targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                >
                  <MenuItem
                    primaryText="Download PDF"
                    onClick={this.handleDownloadContact}
                  />
                  <MenuItem
                    primaryText="Delete contact"
                    onClick={this.handleDeleteContact}
                  />
                </IconMenu>
                <div
                  className="pull-right"
                  style={{
                    display: 'inline-block',
                    paddingTop: 20,
                  }}
                >
                  <TextField
                    floatingLabelText="Status"
                    value={fields.status}
                    onChange={this.handleOnChange('status')}
                    style={styles.txtField}
                    underlineStyle={styles.underline}
                    floatingLabelStyle={styles.floatingLabel}
                    floatingLabelFixed={true}
                    errorStyle={styles.errorStyle}
                  />
                </div>
                <div className="clearfix" />
                <div
                  style={{
                    display: 'inline-block',
                    marginTop: '-7px',
                    marginBottom: 6,
                  }}
                >
                  <span>Channel Source: {contact.source}</span>
                  <br />
                  <span>
                    Creation Date: {Moment(contact.created_at).format('MMM D')}
                  </span>
                </div>
              </div>
              <div className="contact-body-wrapper" style={styles.contactBody}>
                <Row>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="First Name"
                      fullWidth={true}
                      onChange={this.handleOnChange('firstname')}
                      errorText={fieldErrors.firstname}
                      value={fields.firstname}
                      floatingLabelFixed={true}
                      autoComplete='none'
                    />
                  </Col>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Last Name"
                      fullWidth={true}
                      onChange={this.handleOnChange('lastname')}
                      errorText={fieldErrors.lastname}
                      value={fields.lastname}
                      floatingLabelFixed={true}
                      autoComplete='none'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Mobile phone"
                      fullWidth={true}
                      onChange={this.handleOnChange('mobile')}
                      errorText={fieldErrors.mobile}
                      value={fields.mobile}
                      floatingLabelFixed={true}
                    >
                      <MaskedInput
                        value={fields.mobile}
                        mask={fields.mobile? this.handleMask : []}
                        autoComplete='none'
                        
                      />
                    </TextField>
                  </Col>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Email Address"
                      fullWidth={true}
                      onChange={this.handleOnChange('email')}
                      value={fields.email}
                      floatingLabelFixed={true}
                      autoComplete='none'
                      errorText={fieldErrors.email}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'start',
                      alignItems: 'center',
                    }}
                  >
                    <h4>Contact Groups</h4>
                    <IconButton style={{}} onClick={this.showGroupMenu}>
                      <AddCircle color="rgb(76, 175, 80)" />
                    </IconButton>

                    <Popover
                      open={this.state.groupMenuOpen}
                      anchorEl={this.state.anchorEl}
                      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                      targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                      onRequestClose={this.hideGroupMenu}
                    >
                      <Menu>
                        <MenuItem
                          primaryText="Add to Group"
                          onClick={() => {
                            this.openAddToGroupDialog()
                          }}
                        />
                        <MenuItem
                          primaryText="Create New Group"
                          onClick={() => {
                            this.openCreateGroupDialog()
                          }}
                        />
                      </Menu>
                    </Popover>
                    <Dialog
                      title="Add Contact to Group"
                      modal={false}
                      open={this.state.openAddToGroupDialog}
                      onRequestClose={this.closeAddToGroupDialog}
                    >
                      <Table>
                        <TableHeader
                          displaySelectAll={false}
                          adjustForCheckbox={false}
                          enableSelectAll={false}
                        >
                          <TableRow>
                            <TableHeaderColumn>Group Name</TableHeaderColumn>
                            <TableHeaderColumn>
                              No. of contacts
                            </TableHeaderColumn>
                            <TableHeaderColumn>Creation Date</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: 'center' }}>
                              &nbsp;
                            </TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                          {availableGroups}
                        </TableBody>
                      </Table>
                    </Dialog>

                    <Dialog
                      title="Create Group"
                      modal={false}
                      open={this.state.openCreateGroupDialog}
                      onRequestClose={this.closeCreateGroupDialog}
                      actions={
                        <RaisedButton
                          primary={true}
                          style={{ margin: 10, color: '#fff' }}
                          onClick={this.createNewGroup}
                        >
                          Create
                        </RaisedButton>
                      }
                    >
                      <TextField
                        floatingLabelText="Group Name"
                        fullWidth={true}
                        onChange={this.handleChangeNewGroupName()}
                        value={this.state.newGroupName}
                        floatingLabelFixed={true}
                      />
                      <Checkbox
                        label="Add this contact to the new group"
                        labelStyle={{
                          fontSize: '12px',
                          fontWeight: 'normal',
                          color: 'rgb(158,158,158)',
                        }}
                        checked={this.state.addThisContactToNewGroup}
                        onCheck={() => {
                          this.setState({
                            addThisContactToNewGroup: !this.state
                              .addThisContactToNewGroup,
                          })
                        }}
                        //style={styles.checkbox}
                      />
                      <Checkbox
                        label="Private"
                        labelStyle={{
                          fontSize: '12px',
                          fontWeight: 'normal',
                          color: 'rgb(158,158,158)',
                        }}
                        checked={this.state.newGroupIsPrivate}
                        onCheck={() => {
                          this.setState({
                            newGroupIsPrivate: !this.state.newGroupIsPrivate,
                          })
                        }}
                        //style={styles.checkbox}
                      />
                    </Dialog>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>{contactGroups}</Col>
                </Row>

                <Row style={{ marginTop: '72px' }}>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Employment Type"
                      onChange={this.handleOnChange('employmentType')}
                      value={fields.employmentType}
                      floatingLabelFixed={true}
                      autoComplete='none'
                    />
                  </Col>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Shift Req"
                      onChange={this.handleOnChange('shift')}
                      value={fields.shift}
                      floatingLabelFixed={true}
                      autoComplete='none'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Flexible Shifts"
                      onChange={this.handleOnChange('flexibleShifts')}
                      value={fields.flexibleShifts}
                      floatingLabelFixed={true}
                      autoComplete='none'
                    />
                  </Col>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Dept. Req"
                      onChange={this.handleOnChange('interest')}
                      value={fields.interest}
                      floatingLabelFixed={true}
                      autoComplete='none'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Job Fair"
                      onChange={this.handleOnChange('decisionPoint')}
                      value={fields.decisionPoint}
                      floatingLabelFixed={true}
                      autoComplete='none'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <SelectField
                      floatingLabelText="TCPA Status"
                      value={this.state.optStatus}
                      onChange={this.handleChangeOptStatus}
                      floatingLabelFixed={true}
                    >
                      <MenuItem
                        key={0}
                        value={OPTED_IN_OPTION}
                        primaryText="Opted In"
                      />
                      <MenuItem
                        key={1}
                        value={OPTED_OUT_OPTION}
                        primaryText="Opted Out"
                      />
                    </SelectField>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <TextField
                      className="disabled-field"
                      floatingLabelText="TCPA Date"
                      value={
                        fields.optedOutDate
                          ? fields.optedOutDate
                          : fields.optedInDate
                      }
                      disabled={true}
                      floatingLabelFixed={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <TextField
                      floatingLabelText="Notes"
                      value={fields.notes}
                      onChange={this.handleOnChange('notes')}
                      floatingLabelFixed={true}
                    />
                  </Col>
                </Row>
                {browsingmeta}
              </div>
              <div className="profile-footer-wrapper" style={styles.footer}>
                <div className="profile-footer">
                  <RaisedButton
                    label="Save"
                    primary={true}
                    style={{ margin: 10 }}
                    onClick={this.handleSaveUpdate}
                  />
                  <RaisedButton
                    label="Cancel"
                    style={{ margin: 10 }}
                    onClick={this.assignFieldState}
                  />
                </div>
              </div>
            </Col>
            <Thread smWidth={5} updateBot={this.handleUpdateBot} />
          </div>
          <Snackbar
            open={this.state.showSnackBar}
            message={this.state.snackBarMessage}
            autoHideDuration={4000}
            onRequestClose={this.handleSnackBarClose}
          />
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    setContact(contact) {
      return dispatch(setContact(contact))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
